import { InternalScopeIsSailStaff, TInternalScope } from "../../../../domain/codecs/InternalScope";

export const isGuidesAccessAllowed = (userRole: TInternalScope): boolean =>
    InternalScopeIsSailStaff.includes(userRole);
